var React = require('react');

function History (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9.29364 9H30.7064L23.4817 20L30.7064 31H9.29364L16.5183 20L9.29364 9ZM20 21.9853L16.7064 27H23.2936L20 21.9853ZM20 18.0147L16.7064 13H23.2936L20 18.0147Z","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 36C28.8366 36 36 28.8366 36 20C36 11.1634 28.8366 4 20 4C11.1634 4 4 11.1634 4 20C4 28.8366 11.1634 36 20 36ZM20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z","key":1})]);
}

History.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"currentColor"};

module.exports = History;

History.default = History;
